import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    ReferenceInput,
} from 'react-admin';

const TargetCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <ReferenceInput label="Instances" source="instance_id" reference="instances">
                <SelectInput source="name" validate={required()} />
            </ReferenceInput>
            <TextInput source="name" validate={required()} />
            <TextInput source="slug" validate={required()} />
            <TextInput source="type" validate={required()} />
            <TextInput source="account_name" />
            <TextInput source="account_key" />
        </SimpleForm>
    </Create>
);

export default TargetCreate;